<template>
  <v-autocomplete
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    @change="$emit('changed', $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
    :items="items"
    :loading="isLoading"
    :outlined="outlined"
    :search-input.sync="search"
    color="accent"
    :item-text="item_name"
    :item-value="item_value"
    v-model="select"
    hide-no-data
    hide-selected
    clearable
    no-data-text="No results found/loaded yet"
    placeholder="Start typing to Search"
    :prepend-inner-icon="icon"
  >
    <template slot="item" slot-scope="{ item }">
      <span class="body-2"> {{ item.full_name | title }}</span>
      <strong class="px-1 font-weight-bold text-lowercase text-caption"
        >({{ item.full_phone_number }}{{ item.email ? " - " + item.email : "" }})</strong
      >
    </template>

    <template slot="selection" slot-scope="{ item }">
      <span class="body-2"> {{ item.full_name | title }}</span>
      <strong class="px-1 font-weight-bold text-lowercase text-caption"
        >({{ item.full_phone_number }}{{ item.email ? " - " + item.email : "" }})</strong
      >
    </template>
  </v-autocomplete>
</template>

<script>
import baseInput from "./baseInput";
import debounce from "lodash/debounce";

export default {
  props: {
    icon: { default: "mdi-database-search", type: String },
    outlined: { default: true, type: Boolean },
    item_name: { required: true, type: String },
    item_value: { required: true, type: String },
    existing_user: { type: Array, default: () => [] },
    selectedUser: { default: () => {}, type: Object },
  },
  mixins: [baseInput],
  data: function () {
    return {
      items: this.existing_user || [],
      isLoading: false,
      select: this.existing_user[0] || null,
      search: null,
    };
  },

  computed: {},

  mounted() {
    if (this.selectedUser) {
      this.currentVaue = this.selectedUser.id;
    }
  },

  watch: {
    search(value) {
      return this.searchResults(value);
    },
  },
  methods: {
    searchResults: debounce(function (value) {
      if (this.isLoading || !value) return;

      this.isLoading = true;

      // Lazily load input items
      this.$http
        .get(`api/v1/users?search=${value}`)
        .then(({ data, total }) => {
          this.count = total;
          this.items = data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {})
        .finally(() => (this.isLoading = false));
    }, 500),
  },
};
</script>
